export const GST_TREATMENT = {
  INCLUSIVE: 'gst_inclusive',
  EXCLUSIVE: 'gst_exclusive',
  FREE: 'gst_free',
} as const;

export type GstTreatment =
  (typeof GST_TREATMENT)[keyof typeof GST_TREATMENT];

export const GST_TREATMENT_OPTIONS: {
  value: GstTreatment;
  label: string;
}[] = [
  { value: GST_TREATMENT.INCLUSIVE, label: 'Included' },
  { value: GST_TREATMENT.EXCLUSIVE, label: 'Excluded' },
  { value: GST_TREATMENT.FREE, label: 'Not applicable' },
];

/** Display label for a treatment value or legacy includeGST boolean (RW-03). Never Yes/No. */
export const gstTreatmentDisplayLabel = (
  value?: string | null,
  includeGST?: boolean | null
): string => {
  const map: Record<string, string> = {
    [GST_TREATMENT.INCLUSIVE]: 'Included',
    [GST_TREATMENT.EXCLUSIVE]: 'Excluded',
    [GST_TREATMENT.FREE]: 'Not applicable',
    GST_INCLUSIVE: 'Included',
    GST_EXCLUSIVE: 'Excluded',
    GST_FREE: 'Not applicable',
    Included: 'Included',
    Excluded: 'Excluded',
    'Not applicable': 'Not applicable',
    // Harden against legacy Yes/No / boolean-as-string
    Yes: 'Included',
    yes: 'Included',
    true: 'Included',
    '1': 'Included',
    No: 'Excluded',
    no: 'Excluded',
    false: 'Excluded',
    '0': 'Excluded',
  };
  if (value != null && String(value).trim() !== '') {
    const key = String(value).trim();
    if (map[key]) return map[key];
    const lower = key.toLowerCase();
    if (lower === 'yes' || lower === 'true') return 'Included';
    if (lower === 'no' || lower === 'false') return 'Not applicable';
  }
  // Legacy boolean: true = GST exclusive (add 10%); false = GST free
  if (includeGST === true) return 'Excluded';
  if (includeGST === false) return 'Not applicable';
  return '—';
};

/** Resolve stored / legacy values to a GstTreatment enum for selects. */
export const resolveGstTreatmentValue = (
  value?: string | null,
  includeGST?: boolean | null
): GstTreatment => {
  const label = gstTreatmentDisplayLabel(value, includeGST);
  if (label === 'Included') return GST_TREATMENT.INCLUSIVE;
  if (label === 'Not applicable') return GST_TREATMENT.FREE;
  if (label === 'Excluded') return GST_TREATMENT.EXCLUSIVE;
  return GST_TREATMENT.EXCLUSIVE;
};

/** Optional line-item field name for revamp forms (server: `gstTreatment`). */
export const GST_TREATMENT_FIELD = 'gstTreatment';
